module.exports = __webpack_public_path__ + "img/cx9-21.a771bbc9.jpg";